import { render } from "./AllNotification.vue?vue&type=template&id=4871e2d0"
import script from "./AllNotification.vue?vue&type=script&lang=js"
export * from "./AllNotification.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__